export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '9740601', dateTime: 1787196017092 };